import ModalCustom from 'components/Modal/Modal';
import useDeliverableService from 'features/Deliverables/hooks/useDeliverableService';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialogAction } from 'store/actions/dialogsActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';

const DeliverableCreateReportConfirm = () => {
  const { createDeliverableSheet } = useDeliverableService();
  const [t] = useTranslation();
  const { dispatch } = useAppState();
  const open = useSelector((state) => state.dialogs.deliverableCreateReportConfirm);
  const handleClose = () => {
    dispatch(closeDialogAction('deliverableCreateReportConfirm'));
  };

  const submit = async () => {
    await createDeliverableSheet();
    handleClose();
  };
  return (
    <ModalCustom
      open={open}
      modalName="deliverableCreateReportConfirm"
      onClose={handleClose}
      onConfirm={() => submit()}
      confirmText={t('Create_Report')}
      cancelText={t('Cancel')}
      textConfirmDisable={t('Missing_Required_Fields')}
      titleText={t('Create_Report')}
      confirmLoad
    />
  );
};
export default DeliverableCreateReportConfirm;
